<template>
  <div class="a11y-modal">
    <div class="title">
      <h2>Summer Access Update</h2>
    </div>

    <div class="body">
      <div>
        <p>
          Enrolled students can still utilize online therapy on BetterMynd
          during the summer months!
        </p>
        <p>
          Just a friendly reminder: if you plan to be out of state, please
          update your location to match with counselors in your new state of
          residence.
        </p>
        <p v-if="currentLocation">
          Your location is currently set to
          <strong>{{ currentLocation }}</strong>
        </p>
        <p></p>
      </div>
    </div>

    <div class="actions">
      <router-link
        :to="{ path: '/account', query: { highlight: 'currentLocation' } }"
        class="btn btn-primary"
      >
        Update My Location
      </router-link>
      <a
        href="https://bettermynd-students.helpscoutdocs.com/article/54-out-of-state"
        target="_blank"
        rel="noopener noreferrer"
        class="btn btn-secondary"
      >
        Learn More
        <font-awesome-icon
          :icon="['far', 'arrow-up-right-from-square']"
          class="icon alt ml-1"
        />
      </a>
      <button type="button" @click="$modal.close()">Dismiss</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LocationUpdateRequestModal',
  data() {
    return {
      currentLocation: null
    };
  },
  mounted() {
    this.currentLocation = `${this.$store.getters.currentUser.city.name}, ${this.$store.getters.currentUser.city.state_code}`;
  }
};
</script>

<style lang="scss" scoped>
h3.question {
  color: $black;
  font-family: Open Sans, sans-serif;
  font-size: 16px;
  margin: 20px 0 4px 0;
}
.a11y-modal div.title {
  padding: 10px 20px 10px 20px;
  border-bottom: 0px;
}
div.body {
  margin: 0 24px 0 24px;
}
p {
  margin-top: 0;
  margin-bottom: 1rem;
  font-size: 14px;
}

.actions {
  justify-content: flex-start;

  a,
  button {
    color: $off-blue;
  }

  button {
    margin-left: 0;
  }

  .btn {
    margin-right: 1rem;
  }

  .btn-primary {
    border-color: #1b3a59;
    background: #1b3a59;
    color: #fff;
    margin-left: 8px;

    a {
      color: #fff;
    }
  }

  .btn-secondary {
    border-color: #1b3a59;
    background: rgba(255, 255, 255, 0.1);
    color: $off-blue;
    border-width: 1px;
    border-style: solid;
    &:hover {
      background: rgba(255, 255, 255, 0);
    }
  }
}
</style>
